import type { ReactNode } from 'react';
import './Modal.css';

const Modal = ({ onClose, children }: { onClose: () => void; children?: ReactNode }) => (
  <div className="modal">
    <button className="close" onClick={onClose}>
      Close
    </button>
    {children}
  </div>
);

//<div className="modal" position="fixed">
export default Modal;
